import { makeNoteAPIs } from '../../modules/noteAPIFactory'
import { getOrderNoteListData } from './mockData'
import type { IOrderNote } from '~/types/note/models'

export const {
  getNotes: getOrderNotes,
  postNote: postOrderNote,
  patchNote: patchOrderNote,
  deleteNote: deleteOrderNote,
  handlers,
} = makeNoteAPIs<IOrderNote>({
  apiPathEntityNamePrefix: 'order',
  getNoteListDataFn: getOrderNoteListData,
})
